import { withNamespaces } from 'react-i18next';
import { Card, CardBody, Col, Row } from 'reactstrap';

import { FreightSummaryWidgets } from '../constants';

const SummaryWidgets = ({
    t,
    widgets = [],
}) => {
    return (
        <Row>
            {widgets.map((widget) => {
                const widgetInfos = FreightSummaryWidgets[widget.key];
                const isPositiveTrend = widget.trend === 'up';

                return (
                    <Col className="mb-4" key={widget.key} sm="6" xl>
                        <Card className="h-100 mb-0">
                            <CardBody className="d-flex align-items-center">
                                <div className="avatar-sm me-3">
                                    <span className={`avatar-title rounded-circle bg-soft-${widgetInfos.color} text-${widgetInfos.color} font-size-24`}>
                                        <i className={widgetInfos.icon} />
                                    </span>
                                </div>

                                <div className="flex-1 overflow-hidden">
                                    <h4 className="mb-0 fw-bold">
                                        {widget.amount}
                                    </h4>

                                    <p className="text-truncate text-muted mb-1">
                                        {t(widget.title)}
                                    </p>

                                    <span className={`font-size-11 me-1 ${isPositiveTrend ? 'text-success' : 'text-danger'}`}>
                                        <i className={`${isPositiveTrend ? 'ri-arrow-up-line' : 'ri-arrow-down-line'} align-middle`} />
                                        {widget.rate}
                                    </span>

                                    <small className="text-muted">
                                        {t('vs. last month')}
                                    </small>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                );
            })}
        </Row>
    );
};

export default withNamespaces()(
    SummaryWidgets
);
